export enum SmsActionType {
  SET_UPDATE_NEWSMS_LIST = "SET_UPDATE_NEWSMS_LIST",
  SET_REDUCE_NEWSMS_DATA = "SET_REDUCE_NEWSMS_DATA",
}
